export class CashReceiptAttachmentResultDto {
    fileStoreId: number;
    fileName: string;
    fileExtension: string;
    description: string;
    downloadUrl: string;
}
